import Dialog from "@hydrologiq/shared/chakra/Dialog"
import { ActionButton, ArchiveButton } from "@hydrologiq/shared/content/components/Button"
import { Text, Dialog as ChakraDialog } from "@chakra-ui/react"
import { useState } from "react"
import { ArchiveAssetDocument } from "@hydrologiq/gql-experience/graphql"
import { useMutationWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"
import { DEFAULT_COPY_MAPPINGS } from "@hydrologiq/shared/copy/constants"
import { COPY_KEYS } from "@hydrologiq/shared/copy/constants"
import { useCopyValues } from "@hydrologiq/shared/providers/helpers/useCopy"
import { emitSectionEvent, SECTION_EVENTS } from "@hydrologiq/shared/hooks/useSectionEvent"

const AssetArchive = ({ asset, onAssetRemoved }: { asset?: string; onAssetRemoved: (id: string) => void }) => {
  const [archiveAsset, { loading }] = useMutationWithEndpoint(ArchiveAssetDocument, undefined, "primary")

  const [open, setOpen] = useState(false)

  const onArchive = () => {
    if (asset) {
      archiveAsset({ variables: { id: asset } }).then(() => {
        onAssetRemoved(asset)
        setOpen(false)
        emitSectionEvent(SECTION_EVENTS.ASSET_DELETED)
      })
    }
  }

  const copy = useCopyValues({
    [COPY_KEYS.HEADINGS.ASSET]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.ASSET],
  })
  const assetCopy = copy[COPY_KEYS.HEADINGS.ASSET].toLocaleLowerCase()

  return (
    <Dialog
      title={`Delete ${assetCopy}`}
      trigger={<ArchiveButton disabled={!asset} />}
      footer={
        <>
          <ChakraDialog.ActionTrigger asChild>
            <ActionButton
              disabled={loading}
              context={{ label: "Delete", description: `Delete the current ${assetCopy}`, variant: "secondary" }}
              onClick={onArchive}
            />
          </ChakraDialog.ActionTrigger>
          <ActionButton
            disabled={loading}
            onClick={() => setOpen(false)}
            context={{
              label: "Cancel",
              description: `Do not delete the current ${assetCopy}`,
              variant: "primary",
            }}
          />
        </>
      }
      loading={loading}
      disabled={loading}
      open={open}
      setOpen={setOpen}
    >
      <Text>Are you sure you want to delete this {assetCopy}?</Text>
    </Dialog>
  )
}

export default AssetArchive
